
import React from "react";
import { Separator } from "@/components/ui/separator";
import FAQItem, { FAQItemProps } from "./FAQItem";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export interface FAQSectionProps {
  title?: string;
  faqs: Array<Omit<FAQItemProps, 'className'>>;
  variant?: "card" | "simple";
  className?: string;
  contentClassName?: string;
}

const FAQSection: React.FC<FAQSectionProps> = ({ 
  title = "Frequently Asked Questions",
  faqs, 
  variant = "simple",
  className,
  contentClassName
}) => {
  const renderContent = () => (
    <div className={cn("space-y-4", contentClassName)}>
      {faqs.map((faq, index) => (
        <FAQItem
          key={index}
          question={faq.question}
          answer={faq.answer}
          defaultOpen={faq.defaultOpen}
        />
      ))}
    </div>
  );

  if (variant === "card") {
    return (
      <Card className={className}>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent>
          {renderContent()}
        </CardContent>
      </Card>
    );
  }

  return (
    <section className={className}>
      {title && (
        <>
          <h2 className="text-2xl font-bold mb-6 text-center">{title}</h2>
          <Separator className="my-6" />
        </>
      )}
      
      <div className="max-w-3xl mx-auto">
        {renderContent()}
      </div>
    </section>
  );
};

export default FAQSection;
